module.exports = __webpack_public_path__ + "static/media/person1.4956a2ea.png";